import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const ManageTemplatesRaw = React.lazy(() => import(/* webpackChunkName: "ManageClientTemplates" */ './ManageTemplates'));
export const ManageTemplates = () => (React.createElement(Page, { title: "Manage Templates", description: "Manage Templates" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(ManageTemplatesRaw, null)))));
